/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SCIMGroupMappingWrite = {
  display_name?: string;
  role_mapped: SCIMGroupMappingWrite.role_mapped;
};
export namespace SCIMGroupMappingWrite {
  export enum role_mapped {
    '_0' = 0,
    '_2' = 2,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8,
  }
}

